import Vue from "vue";
import { DropdownPlugin, ModalPlugin, BadgePlugin, ButtonPlugin } from "bootstrap-vue";

// Install BootstrapVue
Vue.use(DropdownPlugin);
Vue.use(ModalPlugin);
Vue.use(BadgePlugin);
Vue.use(ButtonPlugin);
// Optionally install the BootstrapVue icon components plugin
//Vue.use(IconsPlugin);